'use client';

import React from 'react';
import { TeamTable } from '../components/employee/TeamTable';

export function TeamMembers() {
  return (
    <main className="flex-1 overflow-y-auto p-6">
      <TeamTable 
        title="Team Members" 
        subtitle="Manage your school staff and assign roles" 
      />
    </main>
  );
}
